import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { T } from "@repo/transifex";
import { Button } from "~/components";

type DeviceProps = {
  identifier: string | null;
  connectRoute?: string;
  onConnect?: () => void;
  onDisconnect?: () => void;
  /** Rendered next to Disconnect while a device is connected. */
  secondaryAction?: ReactNode;
};

export const DeviceConnect = ({
  identifier,
  connectRoute,
  onConnect,
  onDisconnect,
  secondaryAction
}: DeviceProps) => {
  if (identifier) {
    return (
      <div className="flex w-full items-center justify-between">
        <p className="text-base text-text-primary">{identifier}</p>

        <div className="flex items-center gap-3">
          {secondaryAction}

          <Button onClick={onDisconnect} variant="danger">
            <T _str="Disconnect" />
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-full items-center justify-between">
      <p className="text-base text-text-primary">
        <T _str="No device connected" />
      </p>

      {connectRoute ? (
        <Link to={connectRoute}>
          <Button onClick={onConnect}>
            <T _str="Select device" />
          </Button>
        </Link>
      ) : (
        <Button onClick={onConnect}>
          <T _str="Select device" />
        </Button>
      )}
    </div>
  );
};
